export const adviseScheemas = [
  {
    code: 'SIGN_DOCUMENT',
    form_element_groups: [
        {
          id: '1',
          code: 'G_SIGN_DOCUMENT',
          subCategory: [],
          form_element: [
            {
              id: '1-1',
              code: 'G_SIGN_DOCUMENT_E_ATTACHMENT',
            },
            {
              id: '1-2',
              code: 'G_SIGN_DOCUMENT_E_PERSONAL_NUMBER',
            },
            {
              id: '1-3',
              code: 'G_SIGN_DOCUMENT_E_CITIZENSHIP',
            },
            {
              id: '1-4',
              code: 'G_SIGN_DOCUMENT_E_FIRST_NAME',
            },
            {
              id: '1-5',
              code: 'G_SIGN_DOCUMENT_E_LAST_NAME',
            },
            {
              id: '1-6',
              code: 'G_SIGN_DOCUMENT_E_PHONE_NUMBER',
            },
            {
              id: '1-7',
              code: 'G_SIGN_DOCUMENT_E_SIGNATORY_EMAIL_ADDRESSES',
            },
            {
              id: '1-8',
              code: 'G_SIGN_DOCUMENT_E_COMMENT',
            },
          ]
        }
    ],
  }
];
